// @ts-nocheck
import { VERIFY_EMAIL_ERROR, VERIFY_EMAIL_LOADING, VERIFY_EMAIL_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const verifyEmail = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: VERIFY_EMAIL_LOADING,
                data: true
            })
            Authservices.verifyEmail(data).then((data) => {
                if (!data) {
                    dispatch({ type: VERIFY_EMAIL_ERROR, data: { message: 'Request failed. Please try again.' } })
                    return reject({ message: 'Request failed. Please try again.' });
                }
                if (data?.status === 200) {
                    dispatch({
                        type: VERIFY_EMAIL_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
                dispatch({ type: VERIFY_EMAIL_ERROR, data: { message: 'Unexpected response. Please try again.' } })
                return reject({ message: 'Unexpected response. Please try again.' });
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: VERIFY_EMAIL_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}